import { createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      height: "100%",
      boxSizing: "border-box",
      paddingTop: theme.mixins.toolbar.minHeight,
      backgroundColor: theme.palette.background.default,
    },
    expand: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    rootMd: {
      paddingLeft: "83px",
      display: "flex",
      flexDirection: "column",
    },
    container: {
      width: "100%",
      height: "100%",
    },
    main: {
      flexGrow: 1,
    },
    data: {
      color: "black",
    },
    list: {
      display: "inline-grid",
      justifyContent: "right",
      marginTop: "0px",
      marginBottom: "0px",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    listItem: {
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    user: {
      position: "absolute",
      right: 0,
      top: 0,
      margin: "10px",
    },
  })
);
